/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreparedGoogleRowDto
 */
export interface PreparedGoogleRowDto {
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    currency: PreparedGoogleRowDtoCurrencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof PreparedGoogleRowDto
     */
    issueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PreparedGoogleRowDto
     */
    sellDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PreparedGoogleRowDto
     */
    paymentDate: Date;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    exchangeRate?: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    type: PreparedGoogleRowDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    projectNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    teamsNames?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparedGoogleRowDto
     */
    validationError?: string | null;
}


/**
 * @export
 */
export const PreparedGoogleRowDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type PreparedGoogleRowDtoCurrencyEnum = typeof PreparedGoogleRowDtoCurrencyEnum[keyof typeof PreparedGoogleRowDtoCurrencyEnum];

/**
 * @export
 */
export const PreparedGoogleRowDtoTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type PreparedGoogleRowDtoTypeEnum = typeof PreparedGoogleRowDtoTypeEnum[keyof typeof PreparedGoogleRowDtoTypeEnum];


/**
 * Check if a given object implements the PreparedGoogleRowDto interface.
 */
export function instanceOfPreparedGoogleRowDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoiceNumber" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "issueDate" in value;
    isInstance = isInstance && "sellDate" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "comment" in value;

    return isInstance;
}

export function PreparedGoogleRowDtoFromJSON(json: any): PreparedGoogleRowDto {
    return PreparedGoogleRowDtoFromJSONTyped(json, false);
}

export function PreparedGoogleRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreparedGoogleRowDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoiceNumber': json['invoiceNumber'],
        'currency': json['currency'],
        'issueDate': (new Date(json['issueDate'])),
        'sellDate': (new Date(json['sellDate'])),
        'paymentDate': (new Date(json['paymentDate'])),
        'amount': json['amount'],
        'exchangeRate': !exists(json, 'exchangeRate') ? undefined : json['exchangeRate'],
        'type': json['type'],
        'comment': json['comment'],
        'projectNumber': !exists(json, 'projectNumber') ? undefined : json['projectNumber'],
        'teamsNames': !exists(json, 'teamsNames') ? undefined : json['teamsNames'],
        'validationError': !exists(json, 'validationError') ? undefined : json['validationError'],
    };
}

export function PreparedGoogleRowDtoToJSON(value?: PreparedGoogleRowDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoiceNumber': value.invoiceNumber,
        'currency': value.currency,
        'issueDate': (value.issueDate.toISOString()),
        'sellDate': (value.sellDate.toISOString()),
        'paymentDate': (value.paymentDate.toISOString()),
        'amount': value.amount,
        'exchangeRate': value.exchangeRate,
        'type': value.type,
        'comment': value.comment,
        'projectNumber': value.projectNumber,
        'teamsNames': value.teamsNames,
        'validationError': value.validationError,
    };
}

